/* ==========================================================================
   OBAÏA Paris — Version finale · Script commun (Shopify : assets/obaia-global.js)
   - en-tête fixe au défilement, menu mobile
   - moteur d’animations commun (GSAP + ScrollTrigger) : apparitions au
     défilement pour les attributs data-anim, data-reveal, data-lines,
     data-draw et data-rise
   - registre des sections : chaque assets/js/section-*.js s’inscrit avec
     OBAIA.section('nom', { init, anim })

   Valeurs (annotations Figma « Principes généraux (V3) ») :
   - apparition normale : fondu + montée de 16 px, 1 350 ms
   - une par une : décalage 200 ms (180 ms hero et Instagram, 225 ms grilles, 330 ms carrousel)
   - image de haut en bas / de bas en haut : rideau 1 500 à 1 800 ms + zoom 1,04 → 1
   - titres ligne par ligne : 1 350 ms par ligne, décalage 180 ms
   - courbe sine.inOut ; déclenchement à 92 % (petits éléments) / 75 % (grands visuels)
   - sous 1 024 px : durées ×0,8, montée de 12 px, déclenchement à 94 % / 82 %
   - pas de preloader (retiré à la demande de la cliente, confirmé le 01/11)
   - « réduire les animations » : tout est affiché directement
   ========================================================================== */
(function () {
  'use strict';

  var html = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var mq = function (q) { return window.matchMedia(q).matches; };

  var sections = [];
  var OBAIA = window.OBAIA = {
    $: $, $$: $$, reduce: reduce,
    isDesktop: function () { return mq('(min-width: 1024px)'); },
    isMobile: function () { return mq('(max-width: 767px)'); },
    /* Une section s’inscrit : init() tout de suite (comportements),
       anim(fx) quand les animations démarrent (après l’intro du hero) */
    section: function (name, def) { def.name = name; sections.push(def); }
  };

  /* -------------------------------------------------------------------------
     En-tête : devient fixe (fond #F7F7F5, logo brun) une fois le hero dépassé
     ------------------------------------------------------------------------- */
  function headerInit() {
    var header = $('[data-header]'), hero = $('[data-hero]');
    if (!header) return;
    if (!hero) { header.classList.add('is-fixed', 'is-solide'); document.body.style.paddingTop = header.offsetHeight + 'px'; return; } // page sans hero : en-tête blanc d’emblée
    var fixed = false;
    function update() {
      var limit = hero.offsetTop + hero.offsetHeight - header.offsetHeight;
      var should = window.scrollY > limit;
      if (should !== fixed) { fixed = should; header.classList.toggle('is-fixed', fixed); }
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Menu déroulant « La Maison » (desktop) : survol avec un court délai avant de refermer,
     clavier (Tab / Échap). L’en-tête devient blanc tant qu’un menu est ouvert. */
  function sousMenuInit() {
    var header = $('[data-header]');
    $$('[data-sous]').forEach(function (item) {
      var btn = $('[data-sous-btn]', item), t;
      function set(open) {
        clearTimeout(t);
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (header) header.classList.toggle('is-menu', !!$('[data-sous].is-open'));
      }
      item.addEventListener('mouseenter', function () { set(true); });
      item.addEventListener('mouseleave', function () { t = setTimeout(function () { set(false); }, 150); });
      item.addEventListener('focusin', function () { set(true); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) set(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && item.classList.contains('is-open')) { set(false); btn.focus(); } });
    });
    // Menu mobile : rubriques dépliables
    $$('[data-drawer-groupe]').forEach(function (g) {
      var b = $('.drawer__toggle', g);
      b.addEventListener('click', function () {
        var open = !g.classList.contains('is-open');
        g.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* Menu mobile (tiroir) ---------------------------------------------------- */
  function drawerInit() {
    var drawer = $('[data-drawer]');
    if (!drawer) return;
    var openBtn = $('[data-menu-open]'), closeBtn = $('[data-menu-close]', drawer);
    function open() {
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 450);
      openBtn.focus();
    }
    openBtn && openBtn.addEventListener('click', open);
    closeBtn && closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* =========================================================================
     ANIMATIONS
     ========================================================================= */
  function motionOK() {
    return !reduce && html.classList.contains('anim') && window.gsap && window.ScrollTrigger;
  }

  function buildFx() {
    var gsap = window.gsap;
    var M = !OBAIA.isDesktop();                 // mobile + tablette
    // Retour de Chaima du 28/10 : « c'est beau, mais trop lent, ça va faire fuir ».
    // Toutes les durées sont divisées par deux (VITESSE) et l'easing démarre vite (power2.out) :
    // le contenu est lisible presque aussitôt, l'animation reste un accompagnement.
    var VITESSE = 0.5;
    var K = (M ? 0.8 : 1) * VITESSE;            // durées ×0,8 sous 1 024 px
    var fx = {
      gsap: gsap, M: M, K: K,
      EASE: 'power2.out',
      RISE: M ? 10 : 14,
      APPEAR: 1.35 * K,                         // apparition normale
      LINE: 1.35 * K, LINE_STAGGER: 0.18 * K,   // titres ligne par ligne
      REVEAL: 1.5 * K,                          // rideau
      AFTER: 0.7 * K,                           // ce qui suit une image attend ≈ 0,7 s
      STEP: 0.2 * K                             // une par une
    };

    /* Déclenchement dès l'entrée à l'écran (le contenu n'attend pas qu'on défile davantage) :
       petits éléments à 100 %, grands visuels (> 35 % de l’écran) à 90 % */
    fx.start = function (el) {
      var tall = el.offsetHeight > window.innerHeight * 0.35;
      return tall ? 'top 90%' : 'top 100%';
    };

    /* Apparition normale : fondu + montée */
    fx.appear = function (tl, el, at, o) {
      o = o || {};
      tl.fromTo(el, { opacity: 0, y: o.y != null ? o.y : fx.RISE },
        { opacity: 1, y: 0, duration: o.dur || fx.APPEAR, ease: fx.EASE, clearProps: 'transform' }, at);
      return tl;
    };

    /* Rideau de haut en bas (down) ou de bas en haut (up) + zoom 1,04 → 1 de l’image */
    fx.reveal = function (tl, el, at, o) {
      o = o || {};
      var up = (o.dir || el.getAttribute('data-reveal')) === 'up';
      var dur = o.dur || (parseFloat(el.getAttribute('data-dur')) || 1.5) * K;
      tl.fromTo(el, { clipPath: up ? 'inset(100% 0% 0% 0%)' : 'inset(0% 0% 100% 0%)' },
        { clipPath: 'inset(0% 0% 0% 0%)', duration: dur, ease: fx.EASE,
          onComplete: function () { el.style.clipPath = 'none'; } }, at);   // état final figé (le CSS de départ ne reprend pas la main)
      var media = $$(':scope > img:not(.survol__img), :scope > video, :scope > .media > img, :scope > span > img', el)[0];
      if (media) {
        media.style.transition = 'none';
        tl.fromTo(media, { scale: 1.04 }, { scale: 1, duration: dur, ease: fx.EASE, clearProps: 'transform',
          onComplete: function () { media.style.transition = ''; } }, at);
      }
      return dur;
    };

    /* Titre découpé en lignes ; chaque ligne monte depuis un masque */
    fx.split = function (el) {
      var original = el.innerHTML;
      var parts = [];
      function words(text, tag) {
        text.split(/(\s+)/).forEach(function (t) {
          if (!t) return;
          parts.push(/^\s+$/.test(t) ? ' ' : '<span class="w"' + (tag ? ' data-tag="' + tag + '"' : '') + '>' + t + '</span>');
        });
      }
      Array.prototype.forEach.call(el.childNodes, function (n) {
        if (n.nodeType === 3) words(n.textContent);
        else if (n.nodeName === 'BR' || !n.textContent.trim()) parts.push(n.outerHTML);
        else words(n.textContent, n.nodeName.toLowerCase()); // ex. <em> : mots en italique conservés
      });
      el.innerHTML = parts.join('');
      var lines = [], top = null;
      $$('.w', el).forEach(function (w) {
        var t = w.offsetTop;
        if (top === null || Math.abs(t - top) > 4) { lines.push([]); top = t; }
        var tag = w.getAttribute('data-tag');
        lines[lines.length - 1].push(tag ? '<' + tag + '>' + w.textContent + '</' + tag + '>' : w.textContent);
      });
      el.innerHTML = lines.map(function (l) { return '<span class="line"><span class="line__in">' + l.join(' ') + '</span></span>'; }).join('');
      return { inner: $$('.line__in', el), restore: function () { el.innerHTML = original; } };
    };
    fx.lines = function (tl, el, at) {
      var s = fx.split(el);
      gsap.set(el, { opacity: 1 });
      tl.fromTo(s.inner, { yPercent: 105 }, { yPercent: 0, duration: fx.LINE, ease: fx.EASE, stagger: fx.LINE_STAGGER, onComplete: s.restore }, at);
      return fx.LINE_STAGGER * s.inner.length;   // la suite démarre après le départ de la dernière ligne
    };

    /* Trait qui se dessine depuis le centre (0 → 64 px, 900 ms) */
    fx.draw = function (tl, el, at) {
      tl.fromTo(el, { scaleX: 0 }, { scaleX: 1, duration: 0.9 * K, ease: fx.EASE }, at);
    };

    /* Photos Instagram : montée de 90 px (60 px mobile) en fondu, 1 800 ms */
    fx.rise = function (tl, el, at) {
      tl.fromTo(el, { opacity: 0, y: M ? 60 : 90 }, { opacity: 1, y: 0, duration: 1.8 * K, ease: fx.EASE, clearProps: 'transform' }, at);
    };

    /* Déclencheur unique : build(tl) construit l’animation quand el entre à l’écran.
       Déjà dépassé (défilement rapide) : tout est mis en place directement. */
    fx.when = function (el, build, o) {
      o = o || {};
      window.ScrollTrigger.create({
        trigger: el, once: true,
        start: o.start || function () { return fx.start(el); },
        onEnter: function () {
          var tl = gsap.timeline();
          build(tl);
          if (el.getBoundingClientRect().bottom < 0) tl.progress(1);
        }
      });
    };

    /* Éléments alignés sur une même rangée : une par une (décalage step),
       chaque rangée part quand elle entre à l’écran */
    fx.rows = function (items, build, step) {
      var rows = [];
      items.forEach(function (it) {
        var top = Math.round(it.getBoundingClientRect().top + window.scrollY);
        var row = rows.filter(function (r) { return Math.abs(r.top - top) < 8; })[0];
        if (!row) { row = { top: top, items: [] }; rows.push(row); }
        row.items.push(it);
      });
      rows.forEach(function (row) {
        fx.when(row.items[0], function (tl) {
          row.items.forEach(function (it, k) { build(tl, it, k * step); });
        });
      });
    };
    return fx;
  }

  /* ---- Moteur commun : éléments data-* hors sections « sur mesure » --------
     Chaque élément s’anime quand IL entre à l’écran. Ceux qui entrent ensemble
     s’enchaînent dans l’ordre de lecture ; ce qui suit une image dans la même
     section attend qu’elle soit presque dévoilée. */
  function genericReveals(fx) {
    var gsap = fx.gsap;
    var SEL = '[data-anim], [data-reveal], [data-lines], [data-draw], [data-rise]';
    var readyAt = new WeakMap();
    var batchT = 0, batchFrame = null;
    function batchSlot() {
      if (!batchFrame) batchFrame = requestAnimationFrame(function () { batchT = 0; batchFrame = null; });
      return Math.min(batchT, 0.6);   // une rafale d'éléments ne fait jamais attendre plus de 0,6 s
    }
    function num(el, attr) { var v = el.getAttribute(attr); return v === null ? null : parseFloat(v); }

    function addTo(tl, el, at) {
      if (el.hasAttribute('data-reveal')) {
        fx.reveal(tl, el, at);
        var after = num(el, 'data-after');
        return after !== null ? after * fx.K : fx.AFTER;
      }
      if (el.hasAttribute('data-lines')) return fx.lines(tl, el, at) + 0.1 * fx.K;
      if (el.hasAttribute('data-draw')) { fx.draw(tl, el, at); return fx.STEP; }
      if (el.hasAttribute('data-rise')) { fx.rise(tl, el, at); return 0.18 * fx.K; }
      fx.appear(tl, el, at);
      var step = num(el, 'data-step');
      return step !== null ? step * fx.K : fx.STEP;
    }

    var els = $$(SEL).filter(function (el) {
      return !el.closest('[data-anim-custom]') && el.offsetParent !== null;
    });
    els.forEach(function (el) {
      var inScroller = el.closest('.carousel__track, .insta__row');
      window.ScrollTrigger.create({
        trigger: el, once: true,
        start: function () { return fx.start(el); },
        onEnter: function () {
          var r = el.getBoundingClientRect();
          // Déjà dépassé, ou hors écran dans un carrousel : en place directement.
          if (r.bottom < 0 || (inScroller && r.left >= window.innerWidth)) {
            gsap.set(el, { opacity: 1, clipPath: 'none', scaleX: 1 }); return;
          }
          var tl = gsap.timeline();
          var sec = el.closest('section, footer');
          var now = performance.now();
          var wait = Math.max(0, ((readyAt.get(sec) || 0) - now) / 1000);
          var at = Math.max(batchSlot(), wait);
          var step = addTo(tl, el, at);
          batchT = at + step;
          if (el.hasAttribute('data-reveal')) readyAt.set(sec, now + (at + step) * 1000);
        }
      });
    });
    // Éléments masqués par le responsive : visibles (au cas où l’écran change de taille)
    $$(SEL).forEach(function (el) { if (el.offsetParent === null && !el.closest('[data-anim-custom]')) gsap.set(el, { opacity: 1, clipPath: 'none', scaleX: 1 }); });
  }

  /* =========================================================================
     Démarrage
     ========================================================================= */
  function boot() {
    headerInit();
    drawerInit();
    sousMenuInit();
    sections.forEach(function (s) { s.init && s.init(); });

    if (!motionOK()) { html.classList.remove('anim'); return; }
    var gsap = window.gsap;
    gsap.registerPlugin(window.ScrollTrigger);
    html.classList.add('anim-ok');
    var fx = OBAIA.fx = buildFx();

    // La section hero donne le départ ; les autres attendent la fin de son intro.
    var hero = sections.filter(function (s) { return s.name === 'hero'; })[0];
    function rest() {
      genericReveals(fx);
      sections.forEach(function (s) { if (s !== hero && s.anim) s.anim(fx); });
      window.ScrollTrigger.refresh();
    }
    if (hero && hero.anim) hero.anim(fx, function (delay) { gsap.delayedCall(Math.max(0, delay), rest); });
    else rest();
    window.addEventListener('load', function () { window.ScrollTrigger.refresh(); });
  }

  /* Éditeur de thème Shopify : quand Chaima modifie une section, Shopify la recharge.
     On relance alors ses comportements (carrousel, vidéo, point produit…) sur la nouvelle version.
     Les animations sont coupées dans l’éditeur (classe design-mode, cf. layout/obaia.liquid). */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-section]');
    var name = el && el.getAttribute('data-section');
    sections.forEach(function (s) { if (s.name === name && s.init) s.init(e.target); });
  });

  // Les titres sont découpés en lignes : on attend les polices.
  document.addEventListener('DOMContentLoaded', function () {
    (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(boot);
  });
})();
